import {
  Drawer,
  GenericIconName,
  ModalDialog,
  desktopAndUpLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useRef} from 'react';
import {HeaderCouponWalletButton} from '../../../features/Coupons/CouponWallet/HeaderCouponWalletButton/HeaderCouponWalletButton';
import {NotificationCenter} from '../../NotificationCenter/NotificationCenter';
import {NotificationCenterDrawerHeader} from '../../NotificationCenter/Stream/NotificationCenterDrawerHeader';
import {useTrackHeaderOriginClick} from '../hooks/useOriginClickTrackingFunction';
import {IconMetaNavigationItemBasket} from './IconMetaNavigationItemBasket';
import {EnableSettingsModalProps} from './IconMetaNavigationItemUser/FlyoutLoggedIn';
import {IconMetaNavigationItemUser} from './IconMetaNavigationItemUser/IconMetaNavigationItemUser';
import {IconMetaNavigationItemWishlist} from './IconMetaNavigationItemWishlist';

interface IconMetaNavigationItemsProps {
  enableSettingsModalComponent: (
    props: EnableSettingsModalProps,
  ) => React.ReactNode;
  notificationBellRef: React.RefObject<HTMLDivElement>;
  className?: string;
}

export const IconMetaNavigationItems: React.FC<
  IconMetaNavigationItemsProps
> = ({enableSettingsModalComponent, className, notificationBellRef}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const trackOriginClick = useTrackHeaderOriginClick();

  const handleClick: React.MouseEventHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    trackOriginClick();
  };

  return (
    <Wrapper data-testid="iconMetaNavigationItems" className={className}>
      <IconAndContentWrapper ref={wrapperRef}>
        <IconMetaNavItemsWrapper>
          <HeaderCouponWalletButton />
          <IconMetaNavigationItemUser
            enableSettingsModalComponent={enableSettingsModalComponent}
            onClick={handleClick}
          />
          <NotificationCenter
            NotificationCenterStreamComponent={Drawer}
            notificationBellRef={notificationBellRef}
            headerContent={
              <NotificationCenterDrawerHeader iconName={GenericIconName.Bell} />
            }
            NewsletterSubscriptionComponent={ModalDialog}
          />
          <IconMetaNavigationItemWishlist onClick={handleClick} />
          <IconMetaNavigationItemBasket onClick={handleClick} />
        </IconMetaNavItemsWrapper>
      </IconAndContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const IconAndContentWrapper = styled.div`
  position: relative;
  height: 100%;
`;

const IconMetaNavItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  max-width: 100%;

  ${tabletAndUpLinaria('gap: 18px;')}
  ${desktopAndUpLinaria('gap: 32px;')}
`;
